/** Users.kycVerified — only 2 is verified. Missing/null/unknown → 0. */

export const KYC = {
  NOT_STARTED: 0,
  IN_PROGRESS: 1,
  VERIFIED: 2,
  REJECTED: 3,
  UNDER_REVIEW: 4,
  REKYC_REQUIRED: 5,
};

export function coerceKycVerified(v) {
  if (v === undefined || v === null || v === "") return KYC.NOT_STARTED;
  const n = Number(v);
  if (!Number.isFinite(n) || n < 0 || n > 5) return KYC.NOT_STARTED;
  return n;
}

export function isKycVerified(v) {
  return Number(v) === KYC.VERIFIED;
}

export function kycBadgeLabel(v) {
  switch (coerceKycVerified(v)) {
    case KYC.IN_PROGRESS:
      return "In progress";
    case KYC.VERIFIED:
      return "Verified";
    case KYC.REJECTED:
      return "Rejected";
    case KYC.UNDER_REVIEW:
      return "Under review";
    case KYC.REKYC_REQUIRED:
      return "Re-KYC required";
    default:
      return "Not started";
  }
}

export function kycBadgeTone(v) {
  switch (coerceKycVerified(v)) {
    case KYC.IN_PROGRESS:
      return "in-progress";
    case KYC.VERIFIED:
      return "verified";
    case KYC.REJECTED:
      return "rejected";
    case KYC.UNDER_REVIEW:
      return "under-review";
    case KYC.REKYC_REQUIRED:
      return "rekyc";
    default:
      return "not-started";
  }
}

export function kycGateMessage(v) {
  switch (coerceKycVerified(v)) {
    case KYC.REJECTED:
      return "Verification was declined. Try again.";
    case KYC.UNDER_REVIEW:
      return "Verification is under review.";
    case KYC.REKYC_REQUIRED:
      return "Please submit KYC again.";
    default:
      return "Complete identity verification.";
  }
}

export function canStartNewDiditSession(v) {
  const n = coerceKycVerified(v);
  return n === KYC.NOT_STARTED || n === KYC.REJECTED || n === KYC.REKYC_REQUIRED;
}

export function kycTradeCtaLabel(v) {
  switch (coerceKycVerified(v)) {
    case KYC.IN_PROGRESS:
      return "Finish verification";
    case KYC.REJECTED:
      return "Kyc Rejected Verify Again";
    case KYC.UNDER_REVIEW:
      return "Verification under review";
    case KYC.REKYC_REQUIRED:
      return "Submit KYC again";
    default:
      return "Submit Kyc";
  }
}

export function diditStatusIsInReview(raw) {
  const s = String(raw || "").trim().toLowerCase();
  return s.includes("review");
}

export function diditStatusIsInProgress(raw) {
  const s = String(raw || "").trim().toLowerCase();
  return s.includes("progress");
}
